// eslint-disable-next-line no-unused-vars
exports.install = function (Vue, options) {
  Vue.prototype.$isMobile = function (threshold) {
    //全局函数1
    return document.body.clientWidth <= threshold;
  };
};
